// Copyright (c) 2020 Deere & Company

import * as fetchService from '../../shared/services/fetch';
import { getBasePath } from '../../shared/services/get-base-path';
import { handleError } from '../../shared/services/error-handlers';

const basePath = getBasePath();

export async function getReports ( ) {

    const endPoint = `${basePath}/reports`;

    const options = {
        method: 'GET'
    };

    try {

        const response = await fetchService.fetch( endPoint, options );

        return response.json();

    } catch ( error ) {

        return handleError( error );
        //  throw error;

    }

}
